import { UserInputViewModel } from "../../model/elearnprofile/types";

export const UPDATE_PROFILE_STARTED = 'UPDATE_PROFILE_STARTED';
export const UPDATE_PROFILE_SUCCEEDED = 'UPDATE_PROFILE_SUCCEEDED';
export const UPDATE_PROFILE_FAILED = 'UPDATE_PROFILE_FAILED';
export const CANCEL_PROFILE_FORM = 'CANCEL_PROFILE_FORM';
export const GET_PROFILE_STARTED = 'GET_PROFILE_STARTED';
export const GET_PROFILE_SUCCEEDED = 'GET_PROFILE_SUCCEEDED';
export const GET_PROFILE_FAILED = 'GET_PROFILE_FAILED';
export const NO_PROFILE_AVAILABLE = 'NO_PROFILE_AVAILABLE';
export const RESET_ELEARN_PROFILE = 'RESET_ELEARN_PROFILE';

export interface UpdateProfileStartedAction {
    type: typeof UPDATE_PROFILE_STARTED;
    payload: string;
}

export interface UpdateProfileSucceededAction {
    type: typeof UPDATE_PROFILE_SUCCEEDED;
    payload: string;
}

export interface UpdateProfileFailedAction {
    type: typeof UPDATE_PROFILE_FAILED;
    payload: string;
}

export interface CancelProfileFormAction {
    type: typeof CANCEL_PROFILE_FORM;
    payload: string;
}

export interface GetProfileStartedAction {
    type: typeof GET_PROFILE_STARTED;
    payload: string;
}

export interface GetProfileSucceededAction {
    type: typeof GET_PROFILE_SUCCEEDED;
    payload: UserInputViewModel;
}

export interface GetProfileFailedAction {
    type: typeof GET_PROFILE_FAILED;
    payload: string;
}

export interface NoProfileAvailableAction {
    type: typeof NO_PROFILE_AVAILABLE;
}

export interface ResetElearnProfileAction {
    type: typeof RESET_ELEARN_PROFILE;
}

export type ElearnProfileActionTypes = UpdateProfileStartedAction
    | UpdateProfileSucceededAction
    | UpdateProfileFailedAction
    | CancelProfileFormAction
    | GetProfileStartedAction
    | GetProfileSucceededAction
    | GetProfileFailedAction
    | NoProfileAvailableAction
    | ResetElearnProfileAction;

export interface License {
    licenseNumber: string;
    state: string;
}

export interface CreditDOB {
    day: number | undefined;
    month: number | undefined;
}

export interface DaysList {
    value: number | undefined;
    name: string;
}

export interface ElearnProfileModel {
    updateCompleted: boolean;
    isLoading: boolean;
    source: string;
    error: string;
    isCancelled: boolean;
    profileData: UserInputViewModel;
    noProfile: boolean;
}